import React from 'react'
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  position: relative;
  padding: 0;
  flex-wrap: wrap;
  justify-content: center;
`;

const Header = styled.div`
    padding: 55px 50px 75px 50px;
    font-size: 20px;
    background-image: linear-gradient(180deg, #40da7a, #0f8e40) !important;

    min-height: 270px;
    height: auto;
    background: white;
  
    -webkit-box-shadow: 0px 0px 25px 2px rgba(49, 46, 14, 0.38);
    box-shadow: 0px 3px 5px 2px rgba(49 46 14 / 10%);
  
    flex: 1;  
    position: relative;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

const LogoContainer = styled.div`    
    top: 8%;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
`;

const Logo = styled.img`
  margin-left: auto;
  margin-right: auto;
  max-width: 45rem;
  max-height: 30rem;
`;

const Cards = styled.div`
  height: 100%;
  position: relative;
  margin: 10%;
  margin-top: 10rem;
  padding: 0px;
`;

const SingleCard = styled.div`
  min-height: 230px;
  height: auto;
  background: white;

  -webkit-box-shadow: 0px 0px 25px 2px rgba(49, 46, 14, 0.38);
  box-shadow: 0px 3px 5px 2px rgba(49 46 14 / 10%);

  flex: 1;
  top: 40px;
  padding: 5px;
  border-radius: 20px;

  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const CardHeadContainer = styled.div`    
    top: -5%;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
`;

const Title = styled.span`    
    background-color: #dcdcdc;
    padding: 12px;
    border-radius: 13px;
    font-weight: bold;
    font-size: 16px;
    color: #666666;
    padding-right: 13px;
    padding-left: 13px;
`;

const IconContainer = styled.div`
    
`;

const Icon = styled.img`
  max-width: 13rem;
  height: auto;
  object-fit: contain;
  margin: 10px;
`;

const Text = styled.p`
  font-size: 15px;
  margin-top: 20px;
  color: #7d7d80;
  padding: 20px;
  text-align: initial;
`;

const Bottom = styled.div`
    margin-top: 6rem;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: #666666;
`;

const Button = styled.button`
  width: 100%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #00d26a;  
  color: white;
  margin-top: 10px;
`;

function NoGeran() {
    return (
        <Container>
            <Header className='row'>
                <LogoContainer>
                    <Logo className='col-md-12 col-sm-12 col-xs-12' alt="logo" src={toAbsoluteUrl("./media/landings/geran/geran.png")} />
                </LogoContainer>
            </Header>
            <Cards>
                <SingleCard className="row">
                    <div className='row'>
                        <CardHeadContainer className='col-12'>
                            <Title>بلیط اتوبوس گران نشد</Title>
                        </CardHeadContainer>
                    </div>

                    <div className='row'>
                        <div className='col-md-9 col-sm-12'>
                            <Text>
                                با توجه به افزایش ۴۵ درصدی هزینه های حمل و نقل در سال جاری پیرو
                                خبر وزارت راه و شهرسازی با در نظر گرفتن تورم و هزینه های ارایه خدمات
                                در بخش های مختلف به منظور تکریم حقوق مشتریان و رعایت عدل و
                                انصاف ایباس بر آن است تا این افزایش قیمت را در حمل و نقل مسافر به
                                کمترین میزان خود برساند و شرایطی را برای خرید ارزان تر بلیط اتوبوس
                                همانند گذشته را فراهم کند.
                            </Text>
                        </div>
                        <div className='col-md-3 col-sm-12'>
                            <IconContainer>
                                <Icon alt="money" src={toAbsoluteUrl("./media/landings/geran/money.gif")} />
                            </IconContainer>
                        </div>
                    </div>

                </SingleCard>
                <Bottom className='row'>
                    <div className='col-12'>
                        همین الان بلیط خود را تهیه کنید:
                    </div>
                    <div className='col-12' style={{ maxWidth: "290px" }}>
                        <a href='/'>
                            <Button>
                                خرید بلیط
                            </Button>
                        </a>
                    </div>
                </Bottom>
            </Cards>


        </Container>
    )
}

export default NoGeran